import service from '@/api/newsletter/setting';
import {loading, handleError} from '@/state/generators/helpers';
import {alert} from "../../generators/helpers";

export const state = {
    service: service('newsletters/settings')
}

export const getters = {}

export const mutations = {}

export const actions = {
    copy: function ({commit, state}, id) {
        loading(commit)

        return state.service.copy(id).then(response => {
            const model = Object.assign({}, response.data)

            commit('ADD_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});
            loading(commit, false)

            return model;
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    createFromNewsletter: function ({commit, state, /*dispatch*/}, {id, data}) {
        loading(commit)

        return state.service.createFromNewsletter(id, data).then(data => {
            const model = Object.assign({}, data.data);

            commit('ADD_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.creation_is_successful'));
            commit('SET_ERRORS', {});

            loading(commit, false);

            return model;
        }).catch((e) => {
            handleError(e, commit);
        })
    },
}
